import createPermission from 'permissions/createPermission'

export const create = createPermission('system.centralStations.create')
export const edit = createPermission('system.centralStations.edit')
export const deferred = createPermission(edit)
